import request from '@/utils/request'

export function list(data) {
    data.json  = true
    let url = '/store/record/list'
    return request.post(url,data)
}

export function all() {
    let url = '/store/record/all'
    return request.get(url)
}

export function down(data) {
    data.json  = true
    let config = {
        responseType: 'arraybuffer',
    }
    let url =  '/store/record/down'
    return request.post(url,data,config)
}

export function info(id) {
    let url = '/store/record/info/' + id
    return request.get(url)
}

export function save(data) {
    data.json = true
    let url = '/store/record/save'
    return request.post(url,data)
}

export function update(data) {
    data.json = true
    let url = '/store/record/update'
    return request.post(url,data)
}

export function remove(data) {
    let url =  '/store/record/delete'
    return request.post(url,data)
}

export function options() {
    let url =  '/store/record/dmz/options'
    return request.get(url)
}

export function upload(file) {
    let url = '/store/record/upload';
    let forms = new FormData()
    forms.append("file",file)
    let config = {
        headers:{'Content-Type':'multipart/form-data'}
    }; //
    return request.post(url,forms,config)
}